exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tab-info-button {\n  display: flex;\n  justify-content: end;\n}\n", ""]);

// exports
